import { useQuery } from '@tanstack/react-query';

import { gqlClient } from '@/api/graphql-client';
import projectKeys from '@/api/queries/project/keyFactory';
import { graphql } from '@/gql';
import { isWithinInterval, subHours } from 'date-fns';

const GetProjectIntegrations = graphql(`
  query GetProjectIntegrations($projectId: ID!) {
    projectById(id: $projectId) {
      integrations {
        publicId
        externalId
        externalUrl
        service
        filesLastSyncedAt
        filesSyncStartedAt
        filesSynced
        materialsLastSyncedAt
        materialsSyncStartedAt
        materialsSynced
      }
    }
  }
`);
const useGetProjectIntegrations = (projectId?: string) => {
  const { data, ...rest } = useQuery({
    enabled: !!projectId,
    queryKey: projectKeys.integrations(projectId!),
    queryFn: () => {
      return gqlClient.request(GetProjectIntegrations, {
        projectId: projectId!,
      });
    },
    refetchInterval: (query) => {
      const integrationIsSyncing =
        query.state.data?.projectById.integrations.some((integration) => {
          return (
            syncIsWithinLastHour(integration.filesLastSyncedAt) ||
            syncIsWithinLastHour(integration.materialsLastSyncedAt)
          );
        });
      return integrationIsSyncing ? 10000 : false; // 10 seconds if syncing, otherwise no refetch
    },
  });

  return { integrations: data?.projectById.integrations, data, ...rest };
};

const syncIsWithinLastHour = (syncStartedAt?: string | null): boolean => {
  if (!syncStartedAt) return false;
  return isWithinInterval(new Date(syncStartedAt), {
    start: subHours(new Date(), 1),
    end: new Date(),
  });
};

export default useGetProjectIntegrations;
